<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>管理</el-breadcrumb-item>
            <!-- :to="{ path: '/' }" -->
            <el-breadcrumb-item>银行卡手动提现审核管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <div style="margin-bottom: 15px;">
            <!-- 提现数据统计 -->
            <div style="display: inline-block; margin-right: 30px;">
                <el-tag type="info" style="margin-right: 10px;">
                    <i class="el-icon-s-data"></i> 总记录数：{{ totalnum }}
                </el-tag>
                <el-tag type="warning" style="margin-right: 10px;">
                    <i class="el-icon-money"></i> 提现总额：{{ totalCashMoney }}元
                </el-tag>
                <el-tag type="success">
                    <i class="el-icon-wallet"></i> 到账总额：{{ totalPayFee }}元
                </el-tag>
            </div>
            
            <!-- 刷新按钮 -->
            <el-button type="primary" size="small" icon="el-icon-refresh" @click="refreshData" :loading="tableDataLoading">
                刷新
            </el-button>
        </div>
        
        <!-- 开关筛选 -->
        <div style="float: right;margin-right:2%;margin-bottom: 15px;">

            <span v-if="alipay == 1"> 支付宝支付开关
                <el-button icon="el-icon-check" circle @click="updateZfbKaiguan(0)"></el-button>
            </span>

            <span v-if="alipay == 0"> 支付宝支付开关
                <el-button icon="el-icon-close" circle @click="updateZfbKaiguan(1)"></el-button>
            </span>
            <span>
                --------
            </span>

            <span v-if="kaiguan == 1"> 手动提现审核管理
                <el-button icon="el-icon-check" circle @click="updateKaiguan(0)"></el-button>
            </span>

            <span v-if="kaiguan == 0"> 手动提现审核管理
                <el-button icon="el-icon-close" circle @click="updateKaiguan(1)"></el-button>
            </span>
            <span>
                --------
            </span>

            <span v-if="offlineMode == 1"> 线下打款模式
                <el-button icon="el-icon-check" circle @click="updateOfflineModeSwitch(0)"></el-button>
            </span>

            <span v-if="offlineMode == 0"> 线下打款模式
                <el-button icon="el-icon-close" circle @click="updateOfflineModeSwitch(1)"></el-button>
            </span>


            <el-select @change="dataSelect()" v-model="handleStatus" placeholder="请选择">
                <el-option v-for="item in states" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>

        <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" prop="outlet" label="网点名称">
            </el-table-column>
            <el-table-column align="center" prop="business" label="业务名称">
            </el-table-column>
            <el-table-column align="center" prop="type" label="提现方式">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.type === 0" type="primary">支付宝</el-tag>
                    <el-tag v-if="scope.row.type === 1" type="success">银行卡</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="userName" label="提现人姓名">
            </el-table-column>
            <el-table-column align="center" prop="cardNum" label="账号" min-width="150">
                <template slot-scope="scope">
                    <span>{{ scope.row.cardNum }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="cashMoney" label="提现总金额">
            </el-table-column>
            <el-table-column align="center" prop="payFee" label="应付金额">
                <template slot-scope="scope">
                    <span style="color: #FF0000;">{{ scope.row.payFee }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="fee" label="手续费">
            </el-table-column>
            <el-table-column align="center" prop="img" label="用户头像">
                <template slot-scope="scope">
                    <el-image style="width: 100px; height: 100px" :src="scope.row.img"
                        :preview-src-list="[scope.row.img]"></el-image>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="nickName" label="用户名">
            </el-table-column>
            <el-table-column align="center" prop="cashTime" label="提现申请时间">
            </el-table-column>

            <el-table-column align="center" prop="auditStatus" label="审核状态">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.auditStatus === 0" type="warning">待审核</el-tag>
                    <el-tag v-if="scope.row.auditStatus === 1" type="success">审核通过</el-tag>
                    <el-tag v-if="scope.row.auditStatus === 2" type="danger">审核拒绝</el-tag>
                </template>
            </el-table-column>

            <el-table-column align="center" prop="state" label="打款状态">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.state === 0" type="info">打款失败</el-tag>
                    <el-tag v-if="scope.row.state === 1" type="success">打款成功</el-tag>
                    <el-tag v-if="scope.row.state === 3" type="warning">打款中</el-tag>
                    <el-tag v-if="scope.row.state === null || scope.row.state === undefined">-</el-tag>
                </template>
            </el-table-column>

            <el-table-column align="center" prop="remark" label="备注" width="150">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.remark" :content="scope.row.remark" placement="top">
                        <span style="cursor: pointer; color: #409EFF;">{{ scope.row.remark.length > 10 ? scope.row.remark.substring(0, 10) + '...' : scope.row.remark }}</span>
                    </el-tooltip>
                    <span v-else>-</span>
                </template>
            </el-table-column>

            <el-table-column align="center" prop="paymentVoucher" label="打款凭证" width="120">
                <template slot-scope="scope">
                    <div v-if="scope.row.paymentVoucher">
                        <el-image 
                            style="width: 60px; height: 60px; cursor: pointer;"
                            :src="scope.row.paymentVoucher" 
                            :preview-src-list="[scope.row.paymentVoucher]"
                            fit="cover">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </div>
                    <span v-else style="color: #909399;">无</span>
                </template>
            </el-table-column>

            <el-table-column align="center" prop="paymentTime" label="打款时间" width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.paymentTime">
                        <i class="el-icon-time"></i> {{ scope.row.paymentTime }}
                    </span>
                    <span v-else>-</span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="180">
                <template slot-scope="scope">
                    <!-- 只有未处理的记录才显示操作按钮 -->
                    <div v-if="!scope.row.handleStatus">
                        <el-button size="mini" type="primary" @click="handlePass(scope.row)">
                            通过
                        </el-button>
                        <el-button size="mini" type="danger" @click="addNotice(scope.row)">
                            拒绝
                        </el-button>
                    </div>
                    <div v-else>
                        <span style="color: #909399;">已处理</span>
                        <el-button v-if="scope.row.paymentVoucher" size="mini" type="text" @click="viewVoucher(scope.row.paymentVoucher)">
                            查看凭证
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: center;margin-top: 10px;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" :current-page="page"
                layout="total,sizes, prev, pager, next" :total="totalnum">
            </el-pagination>
        </div>


        <!-- 拒绝原因对话框 -->
        <el-dialog title="不通过原因" :visible.sync="dialogFormVisible" center width="500px">
            <div style="margin-bottom: 10px;">
                <span style="width: 100px;display: inline-block;text-align: right;">原因：</span>
                <el-input style="width:70%;" v-model="addForm.remark" placeholder="请输入原因"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updates(addForm.id, 2, addForm.remark, '')">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 线下打款凭证上传对话框 -->
        <el-dialog title="上传打款凭证" :visible.sync="dialogVoucherVisible" center width="600px">
            <div style="margin-bottom: 20px;">
                <div style="margin-bottom: 10px;">
                    <span style="font-weight: bold;">提现信息：</span>
                </div>
                <div style="margin-bottom: 5px;">
                    <span>提现方式：</span>
                    <el-tag v-if="currentRow.type === 0" type="primary">支付宝</el-tag>
                    <el-tag v-if="currentRow.type === 1" type="success">银行卡</el-tag>
                </div>
                <div style="margin-bottom: 5px;">
                    <span>收款人姓名：</span>{{ currentRow.userName }}
                </div>
                <div style="margin-bottom: 5px;">
                    <span>收款账号：</span>{{ currentRow.cardNum }}
                </div>
                <div style="margin-bottom: 5px;">
                    <span>提现金额：</span><span style="color: #f56c6c; font-weight: bold;">{{ currentRow.cashMoney }}元</span>
                </div>
                <div style="margin-bottom: 5px;">
                    <span>到账金额：</span><span style="color: #67c23a; font-weight: bold;">{{ currentRow.payFee }}元</span>
                </div>
            </div>
            <el-divider></el-divider>
            <div style="margin-bottom: 10px;">
                <span style="display: inline-block; margin-bottom: 10px;">打款凭证图片：</span>
                <div style="width:148px;height:148px;border: 1px dashed #c0ccda;border-radius: 6px;text-align: center;line-height: 148px;">
                    <el-upload 
                        class="avatar-uploader" 
                        action="https://api.weipaidui.xyz/app-yijiu-backstage/backUpload" 
                        :show-file-list="false"
                        :on-success="handleVoucherUploadSuccess"
                        :before-upload="beforeVoucherUpload">
                        <img v-if="paymentVoucher" :src="paymentVoucher" class="avatar" style="border-radius: 6px;width: 148px;height: 148px;" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
                <div style="color: #999; font-size: 12px; margin-top: 5px;">支持jpg、png格式，大小不超过2MB</div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVoucherVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitVoucher" :loading="submitting">确认打款</el-button>
            </div>
        </el-dialog>

        <!-- 查看凭证对话框 -->
        <el-dialog title="打款凭证" :visible.sync="dialogViewVoucherVisible" center width="600px">
            <div style="text-align: center;">
                <el-image :src="viewVoucherUrl" :preview-src-list="[viewVoucherUrl]" style="max-width: 100%;"></el-image>
            </div>
        </el-dialog>

    </div>
</template>

<script>

import { getTeamManualPayoutList, getTeamBankManualState, auditTeamManualPayout, updateTeamBankManualState, getTeamAlipayState, updateTeamAlipayState, updateOfflineMode } from '../../../api/manage/teamManualPayout.js'

import moment from 'moment';

export default {
    data() {
        return {
            startDate: '',
            endDate: '',
            dateTime: '',
            outlet: '',
            multipleSelection: [],
            totalnum: 0,
            page: 1,
            size: 10,
            kaiguan: '',//手动提现开关 0关     1开    
            alipay: '',
            offlineMode: 0, // 线下打款模式 0关闭 1开启
            totalCashMoney: 0, // 提现总额统计
            totalPayFee: 0, // 到账总额统计
            tableDataLoading: false,
            dialogFormVisible: false,
            dialogVoucherVisible: false, // 打款凭证上传对话框
            dialogViewVoucherVisible: false, // 查看凭证对话框
            viewVoucherUrl: '', // 查看的凭证URL
            handleStatus: 0,
            states: [{
                value: 0,
                label: '未处理'
            },
            {
                value: 1,
                label: '已处理'
            }
            ],
            tableData: [],
            addForm: {
                id: '',
                state: 0,
                remark: ''
            },
            currentRow: {}, // 当前操作的行数据
            paymentVoucher: '', // 打款凭证URL
            submitting: false, // 提交中状态
        }
    },
    components: {

    },

    created() {
        this.dataSelect()
        this.statusLook()
        this.statusAliLook()
        // this.getdata(1)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },



        updateKaiguan(state) {
            let obj = {
                state: state,
            }
            if (state == 1) {
                this.$confirm(`确认打开手动提现开关吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateTeamBankManualState(obj).then(res => {
                        this.$message({
                            type: "success",
                            message: res.msg,
                            duration: 1500,
                            onClose: () => {
                                this.kaiguan = state
                                this.dataSelect()
                            }
                        });
                    })
                }).catch(() => { })
            }
            if (state == 0) {
                this.$confirm(`确认关闭手动提现开关吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateTeamBankManualState(obj).then(res => {
                        this.$message({
                            type: "success",
                            message: res.msg,
                            duration: 1500,
                            onClose: () => {
                                this.kaiguan = state
                                this.dataSelect()
                            }
                        });
                    })
                }).catch(() => { })
            }

        },


        updateZfbKaiguan(state) {
            let obj = {
                state: state,
            }
            if (state == 1) {
                this.$confirm(`确认打开支付宝支付开关吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateTeamAlipayState(obj).then(res => {
                        this.$message({
                            type: "success",
                            message: res.msg,
                            duration: 1500,
                            onClose: () => {
                                this.alipay = state
                                this.dataSelect()
                            }
                        });
                    })
                }).catch(() => { })
            }
            if (state == 0) {
                this.$confirm(`确认关闭支付宝支付开关吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateTeamAlipayState(obj).then(res => {
                        this.$message({
                            type: "success",
                            message: res.msg,
                            duration: 1500,
                            onClose: () => {
                                this.alipay = state
                                this.dataSelect()
                            }
                        });
                    })
                }).catch(() => { })
            }

        },



        // 刷新数据
        refreshData() {
            this.dataSelect();
            this.$message({
                type: 'success',
                message: '刷新成功',
                duration: 1000
            });
        },

        // 处理通过按钮点击
        handlePass(row) {
            this.currentRow = row;
            // 如果是线下打款模式，弹出上传凭证对话框
            if (this.offlineMode == 1) {
                this.paymentVoucher = '';
                this.dialogVoucherVisible = true;
            } else {
                // 线上打款模式，直接调用审核接口
                this.$confirm('确认通过该提现申请吗？系统将自动打款', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.updates(row.id, 1, '', '');
                }).catch(() => {});
            }
        },

        // 提交打款凭证
        submitVoucher() {
            if (!this.paymentVoucher) {
                this.$message.error('请上传打款凭证');
                return;
            }
            this.submitting = true;
            this.updates(this.currentRow.id, 1, '', this.paymentVoucher);
        },

        // 打款凭证上传成功回调（参考轮播图上传方式）
        handleVoucherUploadSuccess(file) {
            this.paymentVoucher = file.msg;
            this.$message.success('图片上传成功');
        },

        // 上传前校验
        beforeVoucherUpload(file) {
            const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isImage) {
                this.$message.error('只能上传 JPG/PNG 格式的图片!');
            }
            if (!isLt2M) {
                this.$message.error('图片大小不能超过 2MB!');
            }
            return isImage && isLt2M;
        },

        // 查看凭证
        viewVoucher(url) {
            this.viewVoucherUrl = url;
            this.dialogViewVoucherVisible = true;
        },

        // 添加拒绝原因弹框
        addNotice(row) {
            this.addForm = {
                id: row.id,
                state: 2,
                remark: '',
            }
            this.dialogFormVisible = true
        },
        
        updates(id, auditStatus, remark, paymentVoucher) {

            // let selectedIds = this.multipleSelection.map(item => item.id)
            // let idsa= selectedIds.join(',')
            let ids = ''
            // if(idsa ===''){
            ids = id
            // }else{
            //     ids=idsa
            // }

            let post = {
                id: ids,
                auditStatus: auditStatus,
                remark: remark,
                paymentVoucher: paymentVoucher || ''
            }
            auditTeamManualPayout(post).then((res) => {
                this.dialogFormVisible = false
                this.dialogVoucherVisible = false
                this.submitting = false
                this.$message({
                    type: "success",
                    message: res.msg,
                    duration: 1500,
                    onClose: () => {
                        this.dataSelect()
                    }
                });
            }).catch(() => {
                this.submitting = false
            })
        },

        // 修改线下打款模式开关
        updateOfflineModeSwitch(mode) {
            let obj = {
                offlineMode: mode,
            }
            let modeText = mode == 1 ? '开启' : '关闭'
            this.$confirm(`确认${modeText}线下打款模式吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateOfflineMode(obj).then(res => {
                    this.$message({
                        type: "success",
                        message: res.msg,
                        duration: 1500,
                        onClose: () => {
                            this.offlineMode = mode
                            this.dataSelect()
                        }
                    });
                })
            }).catch(() => { })
        },

        handleSizeChange(val) {
            this.size = val;
            this.dataSelect()
        },
        handleCurrentChange(val) {
            this.page = val;
            this.dataSelect()
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        statusLook() {
            let post = {

            }
            this.tableDataLoading = true
            getTeamBankManualState(post).then((res) => {
                this.tableDataLoading = false
                if (res.code == 200) {
                    console.log("res=====", res)
                    this.kaiguan = res.data.data
                    this.offlineMode = res.data.offlineMode || 0
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            })

        },

        statusAliLook() {
            let post = {

            }
            this.tableDataLoading = true
            getTeamAlipayState(post).then((res) => {
                this.tableDataLoading = false
                if (res.code == 200) {
                    console.log("res=====", res)
                    this.alipay = res.data.data
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            })

        },

        dataSelect() {
            let post = {
                page: (this.page - 1) * this.size,
                size: this.size,
                handleStatus: this.handleStatus,
            }
            this.tableDataLoading = true
            getTeamManualPayoutList(post).then((res) => {
                this.tableDataLoading = false
                if (res.code == 200) {
                    this.tableData = res.data.list
                    this.totalnum = res.data.count;
                    
                    // 计算提现总额和到账总额
                    this.totalCashMoney = 0;
                    this.totalPayFee = 0;
                    if (this.tableData && this.tableData.length > 0) {
                        this.tableData.forEach(item => {
                            if (item.cashMoney) {
                                this.totalCashMoney += parseFloat(item.cashMoney);
                            }
                            if (item.payFee) {
                                this.totalPayFee += parseFloat(item.payFee);
                            }
                        });
                        // 保留两位小数
                        this.totalCashMoney = this.totalCashMoney.toFixed(2);
                        this.totalPayFee = this.totalPayFee.toFixed(2);
                    }
                    
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            })

        },

    }
}
</script>

<style scoped>
.userRole {
    width: 100%;
}

/* 上传组件样式 */
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
}

.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/manage/teamManualPayout/index.vue